<template>

    <create-account v-if="screen === 'create-account'" @created="onAccountCreated" />
    <select-account v-if="screen === 'select-account'" @account-selected="onAccountSelected" @switch-to-create-account="screen = 'create-account'" />

    <game ref="refGame" @restartAt="restartAt" v-if="screen === 'game'"  />


</template>

<script>

    import Game from "./game1/Game.vue";
    import CreateAccount        from "../components/CreateAccount.vue";
    import SelectAccount        from "../components/SelectAccount.vue";

    export default {
        name: "Game1",
        components: { Game, CreateAccount, SelectAccount }
    }
</script>

<script setup>
    import { computed, ref, onMounted, nextTick } from "vue";

    import { useMainStore }     from "../stores/main";
    import { storeToRefs }      from "pinia";
    import Events               from "../game/events/Events";


    let emits = defineEmits(['playAudio']);
    let screen = ref("");

    let store = useMainStore();
    const { lang, score, accounts, currentUserIndex, lastPage, seenHome  } = storeToRefs(store);
    const { router } = store;


    const { getPreviousPage } = store;
    let previousPage = computed ( () => getPreviousPage());

    let currentLevel = ref (1);
    let refGame = ref(null);

    function restartAt (level = 1)
    {
        currentLevel.value = level;
        screen.value = "game";
    }

    function tempPrevPage ()
    {
        // return {name: 'play', params: { lang: lang.value, id: 1 }};

        //THIS IS SOME TEMP CODE FOR MJ TO TEST SCENE
        currentLevel.value --;
        document.dispatchEvent(new CustomEvent("route-change", {detail: {scene: "foret-" + currentLevel.value}}));
    }

    function nextPage ()
    {
       // return {name: 'play', params: { lang: lang.value, id: 1 }};

        //THIS IS SOME TEMP CODE FOR MJ TO TEST SCENE
        currentLevel.value ++;
        document.dispatchEvent(new CustomEvent("route-change", {detail: {scene: "foret-" + currentLevel.value}}));
    }


    function increaseScore() {
        score.value = score.value + 1;
    }


    function checkForProfile ()
    {

        if (currentUserIndex.value === -1 && accounts.value.length === 1)
        {
            currentUserIndex.value = 0;
        }

        if (currentUserIndex.value > -1)
        {
            screen.value = "game";

            nextTick(() =>
            {

                refGame.value.reset();
                refGame.value.startGame(false);
            });
        }

        else if (accounts.value.length === 0)
        {
            screen.value = "create-account";
        }
        else if (accounts.value.length > 0)
        {
            screen.value = "select-account";
        }
    }

    function onSceneLoaded ()
    {

        if (!seenHome.value)
        {
            document.dispatchEvent(new CustomEvent(Events.MoveScene, {detail: {scene: "foret-1", direct: true}}));
        }

        checkForProfile();
    }

    function onAccountCreated ()
    {
       screen.value = "game";
    }

    function onAccountSelected ()
    {
        screen.value = "game";
    }

    function onPlayAudio (url)
    {
        emits("playAudio", url);
    }

    onMounted(() =>
    {
        document.addEventListener(Events.SceneShown, (e) =>
        {
            checkForProfile();
        });

        if (!seenHome.value)
        {
            //document.dispatchEvent(new CustomEvent(Events.MoveScene, {detail:{scene: "foret-1"}}));
        }

        if (lastPage.value == "") //the page was loaded directly
        {
            checkForProfile();
        }



    });


    defineExpose({ onSceneLoaded });

</script>
